module.exports = __webpack_public_path__ + "media/images/emblems/Bad_Ragaz-Blazono-2672ea13eeb20d4441c0b791875c4e6e.png";